import { formatNumber } from "src/MarketDataComponents/Helpers";
import Link from 'next/link';

const FIELD_DIVIDEND_YIELD = 'dividendYield';
const FIELD_EQUITY_RETURN = 'returnOnEquity';

export default function KeyRatios({keyRatios, quote, isSummary}) {
    
    const TYPE_RATIO = 'Ratio';
    const TYPE_PERCENTAGE = 'Percentage';
    const TYPE_MULTIPLE = 'Multiple';

    const rowMappings = [
        {title: 'PER (E)', type: TYPE_RATIO, fieldName: 'priceEarningsRatio'},
        {title: 'Dividend yield (E)', type: TYPE_PERCENTAGE, fieldName: FIELD_DIVIDEND_YIELD},
        {title: 'Price earning growth (E)',  type: TYPE_RATIO, fieldName: 'priceEarningsGrowth'},
        {title: 'Return on equity', type: TYPE_PERCENTAGE, fieldName: FIELD_EQUITY_RETURN},
        {title: 'Operating margin', type: TYPE_PERCENTAGE, fieldName: 'operatingMargin'},
        {title: 'Earning per share growth (E)', type: TYPE_PERCENTAGE, fieldName: 'earningsPerShare'},
        {title: 'Enterprise value/earnings before interest, taxes, depreciation and amortization', type: TYPE_MULTIPLE, fieldName: 'enterpriseValueOverEBITDA'},
        {title: 'Price to tangible book value', type: TYPE_MULTIPLE, fieldName: 'priceToBookValueRatio'},
        {title: 'Price/Cash flow', type: TYPE_MULTIPLE, fieldName: 'priceCashFlowRatio'},
        {title: 'Price/Sales', type: TYPE_MULTIPLE, fieldName: 'priceSalesRatio'},
    ];
    
    const renderValue = (row) => {
        const { fieldName } = row;
        let value = keyRatios[fieldName];

        if (fieldName === FIELD_DIVIDEND_YIELD) {
            return quote.dividendYield !== "n/a" ? formatNumber(quote.dividendYield, 2) : '-';
        }

        if (value === "n/a") {
            return '-';
        }

        if (fieldName === FIELD_EQUITY_RETURN) {
            value *= 100;
        }

        return formatNumber(value, 2);
    }

    const renderRow = (row, index) => {
        return <tr key={index}>
            <td data-testid={`${row.fieldName}Label`}>{row.title}</td>
            <td className="text-align-right text-align-left-sm" data-testid={`${row.fieldName}TypeValue`}>{row.type}</td>
            <td className="text-align-right text-align-left-sm" data-testid={`${row.fieldName}CompanyValue`}>{renderValue(row)}</td>
        </tr>
    }

    return <>
        {keyRatios ? <>
            <div className="ajb-col-12">
                <div className="ajb-card"> 
                    <h2 className="h4 margin-bottom-0" data-testid="keyRatiosTableHeader">Key ratios</h2>

                    <table className="data-table data-table--medium data-table--scroll highlight margin-top-0 margin-bottom-0">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th className="text-align-right text-align-left-sm" data-testid="companyHeader">Company</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rowMappings.map((row, index) => {
                                return renderRow(row, index);
                            })}
                        </tbody>
                    </table>
                    {isSummary ? <Link href={`/sub/${quote.marketCode}/financials/key-ratios`} data-testid="keyRatiosMoreLink">More</Link> : null}
                </div>
            </div>            
        </> : null}
    </>

}

